import React from "react";

interface IBadgeProps {
  type: BadgeType;
  text: string;
  icon?: string;
}

export enum BadgeType {
  new = "new",
  top = "top",
  set = "set",
  sale = "sale",
  custom = "custom",
  icon = "icon",
}

export const Badge: React.FC<IBadgeProps> = ({type = BadgeType.top, text = "", icon = ""}) => {
  return (
    <span className={`badge--${type}`}>
      {type === BadgeType.icon ? (
        <>
          <i className={`badge--icon__symbol icon icon-${icon}`} />
          <span>{text}</span>
        </>
      ) : (
        text
      )}
    </span>
  );
};
